// src/shared/api/endpoints.js
export const endpoints = {
  auth: {
    login: '/api/v1/auth/login',
    registerIndividual: '/api/v1/auth/register/individual',
    registerCompany: '/api/v1/auth/register/company',
    refresh: '/api/v1/auth/refresh', // ✅ EKLE
  },
  me: {
    get: '/api/v1/me',
  },
  abonelik: {
    planTalep: '/api/v1/pilates/abonelik/plan-talep',
  },
};
